<template>
  <div class="category-page">
    <!-- 顶部导航 -->
    <!-- <div class="header">
      <div class="back-btn" @click="handleBack">
        <img src="@assets/images/return-lg.png" class="back-icon" />
      </div>
      <div class="title">分类</div>
      <div class="more-btn">
        <img src="@assets/images/more.png" class="more-icon" />
      </div>
    </div> -->
    
    <!-- 搜索栏 -->
    <div class="search-bar">
      <input 
        type="text" 
        class="search-input" 
        placeholder="请输入商品名称"
        v-model="searchKeyword"
        @keyup.enter="handleSearch"
      />
      <!-- <img src="@assets/images/search.png" class="search-icon" /> -->
    </div>
    
    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 左侧分类列表 -->
      <div class="category-sidebar">
        <div 
          v-for="(item, index) in categoryList" 
          :key="index"
          class="category-item"
          :class="{ active: activeCategory === item.id }"
          @click="handleCategoryClick(item)"
        >
          {{ item.name }}
        </div>
      </div>
      
      <!-- 右侧商品列表 -->
      <div class="product-area">
        <div v-if="loading" class="loading-container">
          <div class="loading-spinner"></div>
        </div>
        <div v-else-if="currentProducts.length === 0" class="empty-container">
          <div class="empty-text">暂无商品</div>
        </div>
        <div v-else class="product-list">
          <div 
            v-for="(product, index) in currentProducts" 
            :key="index"
            class="product-item"
            @click="handleProductClick(product)"
          >
            <div class="product-image-wrapper">
              <img v-lazy="product.image" :alt="product.name" class="product-image" />
              <div class="tag" v-if="product.tag" :class="product.tagType">{{ product.tag }}</div>
            </div>
            <div class="product-info">
              <div class="product-name">{{ product.name }}</div>
              <div class="product-price">
                <span class="price-symbol">¥</span>
                <span class="price-value">{{ product.price }}</span>
                <span class="price-unit">/期起</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 底部导航 -->

  </div>
</template>

<script>
export default {
  name: 'CategoryPage',
  data() {
    return {
      searchKeyword: '',
      activeCategory: '1',
      loading: false,
      categoryList: [
        { id: '1', name: '生活电器' },
        { id: '2', name: '厨房电器' },
        { id: '3', name: '个护日用' },
        { id: '4', name: '锅具刀具' },
        { id: '5', name: '黄金首饰' },
        { id: '6', name: '家居家纺' },
        { id: '7', name: '手机数码' },
        { id: '8', name: '按摩仪器' },
        { id: '9', name: '健身器械' },
        { id: '10', name: '食品水饮' },
        { id: '11', name: '箱包皮具' },
        { id: '12', name: '水杯水壶' },
        { id: '13', name: '户外装备' }
      ],
      productMap: {
        '1': [
          { id: '1', name: '迪奥烈艳蓝金唇膏 999 3.5g', price: '26.25', image: 'https://via.placeholder.com/150x150', tag: '6期免息', tagType: 'red' },
          { id: '2', name: '海蓝之谜经典型精华面霜30ml', price: '433.00', image: 'https://via.placeholder.com/150x150', tag: '6期免息', tagType: 'green' }
        ],
        '2': [],
        '3': [],
        '4': [],
        '5': [
          { id: '3', name: '圣罗兰小金条口红1966 2.2g', price: '116.33', image: 'https://via.placeholder.com/150x150', tag: '6期免息', tagType: 'gold' },
          { id: '4', name: '海蓝之谜修护唇部精华7ml', price: '233.00', image: 'https://via.placeholder.com/150x150', tag: '6期免息', tagType: 'green' },
          { id: '5', name: '海蓝之谜精粹水150ml', price: '333.00', image: 'https://via.placeholder.com/150x150', tag: '6期免息', tagType: 'green' },
          { id: '6', name: '老庙黄金 0.3g猫眼足金转运珠', price: '39.83', image: 'https://via.placeholder.com/150x150', tag: '6期免息', tagType: 'red' },
          { id: '7', name: '老庙黄金 足金素链1.6g伯爵链', price: '0.00', image: 'https://via.placeholder.com/150x150', tag: '', tagType: '' }
        ],
        '6': [],
        '7': [],
        '8': [],
        '9': [],
        '10': [],
        '11': [],
        '12': [],
        '13': []
      }
    }
  },
  computed: {
    currentProducts() {
      return this.productMap[this.activeCategory] || []
    }
  },
  methods: {
    handleBack() {
      this.$router.back()
    },
    handleSearch() {
      // 搜索逻辑
      console.log('搜索:', this.searchKeyword)
    },
    handleCategoryClick(item) {
      this.activeCategory = item.id
    },
    handleProductClick(product) {
      this.$router.push(`/detail/${product.id}`)
    },
    goHome() {
      this.$router.push('/')
    },
    goUser() {
      this.$router.push('/user')
    }
  }
}
</script>

<style lang="scss" scoped>
.category-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 1.2rem;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem;
  background: #fff;
  
  .back-btn, .more-btn {
    width: 0.8rem;
    height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .back-icon, .more-icon {
    width: 0.4rem;
    height: 0.4rem;
  }
  
  .title {
    font-size: 0.34rem;
    font-weight: 600;
    color: #333;
  }
}

.search-bar {
  display: flex;
  align-items: center;
  margin: 0.2rem;
  padding: 0.2rem 0.3rem;
  background: #fff;
  border-radius: 0.4rem;
  
  .search-icon {
    width: 0.3rem;
    height: 0.3rem;
    margin-right: 0.15rem;
    opacity: 0.5;
  }
  
  .search-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 0.26rem;
    color: #333;
  }
}

.main-content {
  display: flex;
  height: calc(100vh - 2.8rem);
}

.category-sidebar {
  width: 1.8rem;
  background: #f8f8f8;
  overflow-y: auto;
  
  .category-item {
    padding: 0.3rem 0.15rem;
    font-size: 0.24rem;
    color: #666;
    text-align: center;
    border-left: 3px solid transparent;
    
    &.active {
      background: #fff;
      color: #ff4d4f;
      border-left-color: #ff4d4f;
      font-weight: 600;
    }
  }
}

.product-area {
  flex: 1;
  background: #fff;
  overflow-y: auto;
  padding: 0.2rem;
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.loading-spinner {
  width: 0.6rem;
  height: 0.6rem;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #ff4d4f;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.empty-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  
  .empty-text {
    font-size: 0.26rem;
    color: #999;
  }
}

.product-list {
  display: flex;
  flex-wrap: wrap;
}

.product-item {
  width: calc(50% - 0.1rem);
  margin-bottom: 0.2rem;
  
  &:nth-child(odd) {
    margin-right: 0.2rem;
  }
}

.product-image-wrapper {
  position: relative;
  width: 100%;
  padding-top: 100%;
  
  .product-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.1rem;
  }
  
  .tag {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.08rem;
    font-size: 0.18rem;
    color: #fff;
    text-align: center;
    
    &.red {
      background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
    }
    
    &.green {
      background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
    }
    
    &.gold {
      background: linear-gradient(135deg, #faad14 0%, #ffc53d 100%);
    }
  }
}

.product-info {
  padding: 0.1rem;
  
  .product-name {
    font-size: 0.22rem;
    color: #333;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    height: 2.8em;
  }
  
  .product-price {
    display: flex;
    align-items: baseline;
    margin-top: 0.1rem;
    
    .price-symbol {
      font-size: 0.2rem;
      color: #ff4d4f;
      font-weight: bold;
    }
    
    .price-value {
      font-size: 0.28rem;
      color: #ff4d4f;
      font-weight: bold;
    }
    
    .price-unit {
      font-size: 0.18rem;
      color: #ff4d4f;
      margin-left: 0.05rem;
    }
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background: #fff;
  padding: 0.15rem 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  
  .footer-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .footer-icon {
      width: 0.45rem;
      height: 0.45rem;
      opacity: 0.5;
    }
    
    .footer-text {
      font-size: 0.2rem;
      color: #999;
      margin-top: 0.05rem;
    }
    
    &.active {
      .footer-icon {
        opacity: 1;
      }
      
      .footer-text {
        color: #ff4d4f;
      }
    }
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>